import { text } from './Constants'
import './Card.scss'
import 'react-calendar/dist/Calendar.css'
import { generateCardLogo, makeCorrectCardNumberString, makeCorrectExpiryDateString } from './Utils'
import arrowRightImage from '../../../../../../../../images/common/thinner-right-arrow.png'
import selected from '../../../../../../../../images/common/selected.png'
import errorIcon from '../../../../../../../../images/common/error-icon.svg'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const Card = ({ card, viewCards, selectCard, methodError }) => (
  <div
    className={`review-book-visit-payment-methods-card-container ${
      methodError ? 'review-book-visit-payment-methods-card-container-show-error' : ''
    }`}>
    {card ?
      <div className='review-book-visit-payment-methods-card-view-container'>
        <div className='review-book-visit-payment-methods-card-item-container'>
          <img
            className='review-book-visit-payment-method-item-logo'
            src={generateCardLogo(card.Type)}
            alt={text.CARD_TYPE}
          />

          <div className='review-book-visit-payment-method-card-text-container'>
            <div className='review-book-visit-payment-method-card-text'>
              {makeCorrectCardNumberString(card?.Number || '')}
            </div>
            <div className='review-book-visit-payment-method-card-text'>
              {text.EXP} {makeCorrectExpiryDateString(card?.Expiry || '')}
            </div>
          </div>
        </div>
        {viewCards || card.isSelected ?
          <img
            className={`review-book-visit-payment-method-card-arrow ${
              viewCards ? '' : 'review-book-visit-payment-method-card-selected'
            }`}
            src={viewCards ? arrowRightImage : selected}
            alt='arrow-right'
            role='presentation'
            onClick={() => {
              if (viewCards) {
                viewCards(true)
              }
            }}
          />
        : <label
            htmlFor='null'
            className='review-book-visit-payment-method-card-select-text'
            role='presentation'
            onClick={() => {
              selectCard(card)
            }}>
            {text.SELECT_CARD}
          </label>
        }
      </div>
    : <label className='review-book-visit-payment-method-no-payment-label' htmlFor='null'>
        {text.NO_PAYMENT_METHOD}
      </label>
    }
    {methodError ?
      <div className='review-book-visit-payment-method-card-error-container'>
        {/*
         // @ts-expect-error TS2551 -- MIGRATION: not approved, fix when encountered */}
        <img src={errorIcon} className='review-book-visit-payment-method-card-error-icon' alt={text.Error} />
        <label className='review-book-visit-payment-method-card-error-label' htmlFor='null'>
          {methodError}
        </label>
      </div>
    : null}
  </div>
)
